import styled from '@emotion/styled';
import { CgClose } from 'react-icons/cg';
import Arrow from '../../../images/Beak2.svg'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
min-width:1440px ;

  display: flex;
  justify-content: center;

  align-items: center;
  z-index: 10;

    @media (max-width: 1440px) {
   min-width: 768px; 
 
  }
  @media (max-width: 844px) {
   min-width: 390px; 
 
  }

`;

export const ModalOverlayLeft = styled.div`

  
  width: 256px;
  height: 100%;
 min-width: 256px;

  display: flex;
  justify-content: center;

  align-items: center;
  @media (max-width: 1440px) {
   width: 72px; 
  min-width: 72px;
  }
  @media (max-width: 844px) {
     display: none;
      min-width: 390px; 
  } 


`;
export const ModalOverlayRight = styled.div`

  width:calc(100% - 256px);
  height: 100%;
  min-width:1184px;
  background:rgba(29, 29, 57, 0.5); 

  display: flex;

  
  z-index: 10;
  @media (max-width: 1440px) {
min-width: 696px;  
 width:calc(100% - 72px);
  }

  @media (max-width: 1024px) {
     min-width: 696px; 
  }
@media (max-width: 844px) {

     min-width: 390px;
     width: 100%;
  } 

`;

export const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  flex-direction: column;
height:fit-content;
left:28px;

 border-radius: 16px;
padding: 8px 12px;
width: 400px;
  box-shadow: 0 0 40px 0 rgba(195, 195, 195, 0.25);
  background: var(--colors-grey-25);
  position: relative;
  z-index: 1100;
 transition: transform 0.3s ease-in;
&::before{
  content: '';
  width: 21px;
  height: 64px;
  background-image: url(${Arrow});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left:-12px;
  top: 50%;
  z-index: 12;
  transform:translateY(-50%);
  
}
 @media (max-width: 689px) {
     width: 90%;
  } 

&.board1{
  transform:translateY(101.5px);
}
&.board2{
  transform:translateY(221.5px);
}
&.board3{
  transform:translateY(281.5px);
}

&.board4{
  transform:translateY(calc(80vh - 113.5px));
}
&.board5{
  transform:translateY(calc(80vh - 43.5px));
}
&.board6{

transform:translate(-344px, 125.5px);
  &::before{

transform:rotate(180deg) translateY(50%);
  left:unset;
  right:-12px;

 
}


}

   @media (max-width: 1440px) {
  &.board1{
  transform:translateY(68.5px);
}
&.board2{
  transform:translateY(188.5px);
}
&.board3{
  transform:translateY(248.5px);
}

&.board4{
  transform:translateY(calc(80vh - 118.5px));
}
&.board5{
  transform:translateY(calc(80vh - 48.5px));
}
&.board6{

transform:translate(-310px, 110.5px);
  &::before{

transform:rotate(180deg) translateY(50%);
  left:unset;
  right:-12px;

 
}


}
 
  }

 @media (max-width: 844px) {
     width: 360px;
     left: 18%;
     transform:translate(calc(100vh - 270px));
     &::before{
  content: unset;

  width: 21px;
  height: 64px;
  background-image: url(${Arrow});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left:35px;
  top: unset;
  bottom:-33px;
  z-index: 12;
 
  transform: rotate(-90deg) ;
}
  &.board1{
  transform:translate(-30%,calc(100vh - 270px));
}
&.board2{
  transform:translate(-10%,calc(100vh - 270px));
 &::before{left:103px;}
}
&.board3{
    transform:translate(-10%,calc(100vh - 270px));
   &::before{left:171px;}
}

&.board4{

   transform:translate(40%,calc(100vh - 270px));
     &::before{left:237px;}
}
&.board5{
 
   transform:translate(70%,calc(100vh - 270px));
   &::before{left:304px;}
}
&.board6{

transform:translate(-180px, 210.5px);
  &::before{

transform:rotate(180deg) translateY(50%);
  left:unset;
  right:31px;
  transform: rotate(90deg);
top:-33px
 
}


}
 
  } 



 @media (max-width: 689px) {
  
     width: 360px;
     left: 50%;
     transform:translate(-60%,calc(100vh - 270px));
     &::before{
  content: '';
 
  width: 21px;
  height: 64px;
  background-image: url(${Arrow});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left:35px;
  top: unset;
  bottom:-33px;
  z-index: 12;
 
  transform: rotate(-90deg) ;
}
  &.board1{
  transform:translate(-60%,calc(100vh - 270px));
}
&.board2{
transform:translate(-50%,calc(100vh - 270px));
 &::before{left:140px;}
}
&.board3{
  transform:translate(-50%,calc(100vh - 270px));
   &::before{left:207px;}
}

&.board4{
  
  transform:translate(-50%,calc(100vh - 270px));
     &::before{left:275px;}
}
&.board5{
  transform:translate(-45%,calc(100vh - 270px));
   &::before{left:304px;}
}
&.board6{
right:0;
left: unset;
transform:translate(-15px, 210.5px);
  &::before{

transform:rotate(180deg) translateY(50%);
  left:unset;
  right:31px;
  transform: rotate(90deg);
top:-33px
 
}


}
 
  } 
   
`;

export const CloseBtn = styled(CgClose)`
  position: absolute;
  top: 8px;
  right: 12px;
  width: 24px;
  height: 24px;
  
  color: var(--colors-grey-400);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  :hover {
    color: var(--accent);
  }

 
`;
